document.addEventListener(
  "wpcf7mailsent",
  function (event) {
    setTimeout(() => {
      location = "/contact-submitted";
    }, 2000);
  },
  false
);
